import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import { useHistory } from 'react-router-dom';

import { OnboardingMfa } from '../../../Onboarding/steps/mfa';

// In-flow 2FA enrollment, rendered as one of the funnel's cards (same shell as the other
// steps) rather than a modal layered on top. There's deliberately no close affordance — a
// network-required step can't be dismissed — and the user lands here from the funnel's own
// routing, so it reads as the next step instead of an interruption.
export const MfaEnrollment = ({ network, routePath }) => {
  const history = useHistory();

  return (
    <Flex bg="neutral.0" sx={{ boxShadow: 'medium', borderRadius: 'default', overflow: 'hidden' }}>
      <Box p="40px" width="600px">
        <Box maxWidth="520px" mx="auto">
          <OnboardingMfa
            network={network}
            onComplete={() => history.push(`${routePath}/install-extension`)}
            topGap="0px"
          />
        </Box>
      </Box>
    </Flex>
  );
};

MfaEnrollment.propTypes = {
  network: PropTypes.object,
  routePath: PropTypes.string.isRequired,
};

MfaEnrollment.defaultProps = {
  network: null,
};
